// extracted by mini-css-extract-plugin
export default {"icon":"SessionTypeIcon_icon__fzdNV","svg":"SessionTypeIcon_svg__HBe9x"};